import mixpanel from 'mixpanel-browser';

import { mixpanelToken } from '../utils/envs';
import { isInternalAccess } from '../utils/internal-access';

const shouldAllowLinksTracking = (isAdmin, domQueryElement) => {
  if (isInternalAccess(isAdmin)) return false;
  return !!document.querySelector(domQueryElement);
};

const MixPanelHelper = (userData) => {
  const { createdAt, email, id, lastLogin, name, planType, signupOrigin } = userData;
  if (!email || !id) return null;
  let mixpanelInstance = null;

  const createInstance = () => {
    if (!mixpanelToken) return null;

    mixpanel.init(mixpanelToken);
    mixpanel.identify(id);

    const peopleOptions = {
      $id: id,
      $email: email,
      $name: name,
      $created: new Date(createdAt),
      $last_login: new Date(lastLogin),
      'Plan Type': planType,
      'Signup Origin': signupOrigin,
    };

    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { mobile_phone, termsOfService } = userData;
    if (termsOfService) {
      peopleOptions['Terms of Service'] = termsOfService;
    }

    if (mobile_phone) {
      peopleOptions.mobile_phone = mobile_phone;
    }

    mixpanel.people.set(peopleOptions);

    mixpanel.register({
      $email: email,
      'Plan Type': planType,
      'Signup Origin': signupOrigin,
    });

    return mixpanel;
  };

  const getInstance = () => {
    if (!mixpanelInstance) {
      mixpanelInstance = createInstance();
    }
    return mixpanelInstance;
  };

  return {
    getInstance,
  };
};

export { shouldAllowLinksTracking };

export default MixPanelHelper;
